module.exports = {
  result:
    "Ce coupon offre une remise de %(discountPercent)s%% sur les produits points bleus pecheur.com. Il est valide jusqu'au %(until)s. Ce code est à renseigner lors de la dernière étape de votre commande chez ",
}
